import { Music4 } from 'lucide-react';
import { CONFIG } from '@/config-globals';
import { cn } from '@/lib/utils';

/** Tile azul com o ícone `music-4` — marca do Chordfy no painel (sem imagem raster). */
export const BrandTile: React.FC<{ className?: string; iconClassName?: string }> = ({
  className,
  iconClassName,
}) => (
  <span
    className={cn(
      'flex size-9 shrink-0 items-center justify-center rounded-[10px] border border-accent-line bg-accent-surface',
      className,
    )}
  >
    <Music4 strokeWidth={1.6} className={cn('size-[18px] text-accent-ink', iconClassName)} />
  </span>
);

export const BrandName: React.FC<{ className?: string }> = ({ className }) => (
  <span className={cn('font-display font-extrabold tracking-tight text-white', className)}>
    {CONFIG.APP_NAME}
  </span>
);
